import { useCallback, useState } from "react";
import {
    type AccordionState,
    loadAccordionState,
    saveAccordionState,
} from "@/appInterface/windows/shapeToolSubMenu/utils";

export const useAccordion = () => {
    const stored = loadAccordionState();

    const [accordionState, setAccordionState] = useState<AccordionState>(
        stored ?? {
            basic: true,
            diagrams: false,
            bpmn: false,
            uml: false,
        },
    );

    const updateSection = useCallback((section: keyof AccordionState, value: boolean) => {
        setAccordionState((prev) => {
            const updated = { ...prev, [section]: value };
            saveAccordionState(updated);
            return updated;
        });
    }, []);

    const collapseAll = useCallback(() => {
        setAccordionState(() => {
            const updated: AccordionState = {
                basic: false,
                diagrams: false,
                bpmn: false,
                uml: false,
            };
            saveAccordionState(updated);
            return updated;
        });
    }, []);

    const expandAll = useCallback(() => {
        setAccordionState(() => {
            const updated: AccordionState = {
                basic: true,
                diagrams: true,
                bpmn: true,
                uml: true,
            };
            saveAccordionState(updated);
            return updated;
        });
    }, []);

    return {
        accordionState,
        updateSection,
        collapseAll,
        expandAll,
    };
};
